import React from 'react';
import styled from 'styled-components';

import { SkeletonBlock } from '@/components/common';
import { media } from '@/styles/theme';

const ContactDrawerHeaderSkeleton = (): React.ReactElement => <SkeletonContent />;
const ContactDrawerSelectSkeleton = (): React.ReactElement => <StyledContractSelect />;

export { ContactDrawerHeaderSkeleton, ContactDrawerSelectSkeleton };

const SkeletonContent = styled(SkeletonBlock)`
  height: 49px;
  width: 300px;
`;

const StyledContractSelect = styled(SkeletonBlock)`
  height: 49px;
  margin-right: 0;

  ${media.laptop} {
    margin-right: 1.5rem;
  }
`;
